import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, Inject, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, Form, FormControl } from '@angular/forms';
import { FormBuilderService } from 'src/app/services/form-builder.service';
import { DatastoreService, ApiService, CommonFunctionsService } from 'src/app/services';
import { DOCUMENT } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'app-form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.scss']
})
export class FormBuilderComponent implements OnInit {

  @Input() formId: string;
  @Input() formData: any = [];
  @Input() showSubmit: boolean = true;
  @Input() booking: any = false;
  @Input() maxChildren: number = 4;
  @Input() uploadSuccess: EventEmitter<boolean>;
  @Output() formSubmitted = new EventEmitter<FormGroup>();
  @Output() formStatus = new EventEmitter<any>();
  @Output() fileStatus = new EventEmitter<any>();

  formFields: any[] = [];
  formGroups: any = {};
  childForms: any[] = [];
  @Input() attachedFiles: any[] = [];
  @Input() deletedFiles: any[] = [];

  detailsTitle: string = '';
  children: any[] = [[]];
  errorLength = 999;
  fileData: any = []

  constructor(
    public formService: FormBuilderService,
    public dataStore: DatastoreService,
    public commonFunctionsService: CommonFunctionsService,
    private api: ApiService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: Document
  ) { }

  ngOnInit(): void {
    console.log('formId', this.formId);
    if (this.dataStore.loadedApplication) {
      if (this.dataStore.loadedApplication.youngPerson.length > 0) {
        this.children = this.dataStore.loadedApplication.youngPerson;
      }
    }
    if (this.uploadSuccess) {
      this.uploadSuccess.subscribe(data => {
         this.preLoadFiles()
      });
    }
    this.populateForms(true);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('formData')) {
      // get the data to add to form
      this.populateForms(changes.formData.currentValue['hafId']);
    }
  }

  async addChild() {
    if (this.children.length < this.maxChildren) {
      const formGroup = await this.formService.buildForm(this.formId, [], this.children.length);
      const formFields = this.formService.getFields(this.formId);
      this.childForms.push(formGroup);
      this.formFields.push(formFields);
      this.children.push([]);

      this.formChanges(this.children.length - 1);

      const script = this.renderer.createElement('script');
      script.type = 'application/javascript';
      script.text = `window.setTimeout(function(){document.getElementById('summary-child-${this.children.length}').click();}, 100);`;

      this.renderer.appendChild(this.doc.body, script);
    }
  }

  removeChild() {
    if (this.children.length > 1) {
      this.children.pop();
      this.formChanges(this.children.length - 1);
    }
  }

  removeChildAtIndex(idx: number) {
    if (this.children.length > 1) {
      this.children.splice(idx, 1);
      this.childForms.splice(idx, 1);
      this.formFields.splice(idx, 1);
      for (const idx in this.children) {
        this.formChanges(parseInt(idx));
        this.forceRevalidationForIndex(parseInt(idx));
      }
    }
  }

  async submit(formId: string) {
    this.formSubmitted.emit(this.formGroups[this.formId]);
  }

  formChanges(idx: number) {
    this.childForms[idx].valueChanges.subscribe((selectedValue: any) => {
      if (this.children[idx]) {
        let currentChild = this.children[idx];
        // now get the values and place them into the array
        // populate the current child
        for (const field of this.formFields[idx]) {
          if (selectedValue.hasOwnProperty(field.field)) {
            const inputtedValue = selectedValue[field.field];
            const foundKey = currentChild.find((f: any) => f.field === field.field);
            if (foundKey) {
              foundKey.value = inputtedValue;
            }
            else {
              currentChild.push({ field: field.field, value: inputtedValue });
            }
          }

          // dates
          if (field.type === 'date') {
            const dobVal: string = selectedValue[field.field + 'y'] + '-' + selectedValue[field.field + 'm'].padStart(2, '0') + '-' + selectedValue[field.field + 'd'].padStart(2, '0');
            this.childForms[idx].controls[field.field].setValue(dobVal, { onlySelf: true });
          }
        }

        // update validators based on conditional fields
        for (const field of this.formFields[idx]) {
          const control: FormControl = this.childForms[idx].get(field.field);
          if (field.conditional) {
            const trigger = this.childForms[idx].get(field.trigger);
            // get value of trigger
            // doing it this way did not work. 
            // see shouldShowConditional in form builder for new way of handling the requirement of conditional fields
            // reason why we don't enable/disable here is that that causes a recursive loop (enabling/disabling counts as a valueChange)
            if (trigger.value !== field.conditional_value) {
              // control.setValidators([]); 
            }
            else {
              // control.setValidators([Validators.required]);
            }
            control.updateValueAndValidity({ onlySelf: true });
          }
        }
        this.forceRevalidationForIndex(idx);
      }
    });
  }

  uploadTest(idx: number, field: any, event: Event) {
    const target: HTMLInputElement = (event.target as HTMLInputElement);
    console.log(target.files);
    for (const file of Array.from(target.files!)) {

      const formData = new FormData();
      // formData.append("file", "");
      formData.append("attachment_id", "");
      formData.set("file", file)
      this.attachedFiles.push(formData);

      let reader = new FileReader();
      console.log(file);
      reader.onload = async (e: any) => {
        console.log(field, this.childForms[idx].get(field.field))
        console.log(this.childForms[idx].get(field.field).controls)
        if (!this.childForms[idx].get(field.field).controls) {
          this.childForms[idx].get(field.field).controls = []
        }
        this.childForms[idx].get(field.field).controls.push(this.formService.createItem({
          file,
          url: e.target.result  //Base64 string for preview image
        }));
        this.fileStatus.emit({
          attachedFiles: this.attachedFiles,
          deletedFiles: this.deletedFiles,
        })
    this.forceRevalidationForIndex(0)
      }
      reader.readAsDataURL(file);
      target.value = '';
    }
  }

  async removeFileAtIndex(fileIdx: number, field: any, idx: number, event: Event) {
    event.preventDefault();
    const deletedFileControl = this.childForms[idx].get(field.field).controls.splice(fileIdx, 1);
    //console.log(deletedFile);
    // now get the file id
    const deletedFile = this.attachedFiles.splice(fileIdx, 1) as any;
    // await this.api.deleteFile(fileId);
    console.log(deletedFile)
    console.log(deletedFile[0])
    console.log(deletedFile[0].uuid)
    if (deletedFile) {
      if (deletedFile[0]) {
        if (deletedFile[0].uuid) {
          this.deletedFiles.push(deletedFile[0])
        }
      }
    }
    this.fileStatus.emit({
      attachedFiles: this.attachedFiles,
      deletedFiles: this.deletedFiles,
    })
    this.forceRevalidationForIndex(0)

  }

  async preLoadFiles() {
    console.log("whyyyy")
    const files: any = await this.api.jrniReadFiles(this.booking.company_id, this.booking.purchase_ref, this.booking.id)
    console.log(files)
    console.log(this.childForms[0])
    const uploadField = this.formFields[0].find((x: any) => x.type === "upload")
    console.log(uploadField)
    this.deletedFiles = []
    this.attachedFiles = []
    this.childForms[0].get(uploadField.field).controls = []
    if (files.attachments) {
      for (let file of files.attachments) {
        console.log(file)
        file.size = file.file_size
        console.log(uploadField.field)
        console.log(this.childForms[0].get(uploadField.field))
        console.log(this.childForms[0].get(uploadField.field).controls)
        this.childForms[0].get(uploadField.field).controls.push(this.formService.createItem({
          file,
          url: file.url  //Base64 string for preview image
        }));
        const formData = new FormData();
        formData.append("attachment_id", "");
        formData.set("file", file)
        this.attachedFiles.push(file)
      }
    }
    console.log(this.attachedFiles)
    console.log(this.childForms[0].get(uploadField.field))
    this.fileStatus.emit({
      attachedFiles: this.attachedFiles,
      deletedFiles: this.deletedFiles,
    })
    this.forceRevalidationForIndex(0)
  }

  onDateChange(reference: string, QuestionsForm: any) {
    const d = QuestionsForm.controls[reference + "d"]
    const m = QuestionsForm.controls[reference + "m"]
    const y = QuestionsForm.controls[reference + "y"]
    if (d.value && m.value && y.value) {
      const date = moment(`${d.value}/${m.value}/${y.value}`, "DD/MM/YYYY")
      if (!date.isValid()) {
        d.setErrors({ error: 'Date is invalid' });
      } else if (date.isBefore(moment().subtract(JSON.parse(this.dataStore.config).eligibility.age + 1, "years"))) { // young person max age 25 (and a person is 25 for a year so +1)
        d.setErrors({ error: 'Child/young person is not eligible' });
      } else {
        d.setErrors(null);
      }
    }
  }

  forceRevalidationForIndex(idx: number) {
    const hasErrors: any[] = [];
    for (const field of this.formFields[idx]) {
      const control: FormControl = this.childForms[idx].get(field.field);
      if (field.conditional) {
        const trigger = this.childForms[idx].get(field.trigger);
        // get value of trigger
        // doing it this way did not work. 
        // see shouldShowConditional in form builder for new way of handling the requirement of conditional fields
        // reason why we don't enable/disable here is that that causes a recursive loop (enabling/disabling counts as a valueChange)
        if (trigger.value !== field.conditional_value) {
          // control.setValidators([]);
        }
        else {
          // control.setValidators([Validators.required]);
        }
        control.updateValueAndValidity({ onlySelf: true });
      }
    }

    for (const field of this.formFields[idx]) {
      const control = this.childForms[idx].get(field.field);
      if (control && !control.disabled) {
        field.value = control.value;
      }
      if (control && control.errors) {
        hasErrors.push({
          field: field,
          control: control
        });
      }
    }
    const atLeastOneCheckbox: any = this.commonFunctionsService.checkBoxGroupsCheck(JSON.parse(this.dataStore.config), this.childForms[idx].controls, this.formId)
    if (!atLeastOneCheckbox.allAtLeastOne) {
      for (let errorField of atLeastOneCheckbox.errorFields)
        hasErrors.push({
          field: errorField,
          control: this.childForms[idx].get(errorField)
        });
    }

    this.dataStore.childrenToRegister = this.children;

    if (this.errorLength !== hasErrors.length) {
      if (hasErrors.length > 0) {
        this.formStatus.emit({
          status: false,
          errors: hasErrors
        });
      }
      else {
        this.formStatus.emit({
          status: true,
          errors: []
        });
      }
    }
    this.errorLength = hasErrors.length
  }

  async populateForms(formDataKey: any) {
    if (formDataKey) {

      let foundChild: any = false;

      for (const [idx, child] of this.children.entries()) {
        console.log(this.formData)
        console.log(this.booking)

        const formGroup: FormGroup = await this.formService.buildForm(this.formId, this.formData, idx);
        const formFields = this.formService.getFields(this.formId);
        // load any defaults
        const defaults: any = [];

        if (this.dataStore.loadedApplication) {
          for (const field of child) {
            let found = formFields.find((f: any) => f.field == field.field);
            if (found) {
              defaults.push(field);
            }
          }
        }
        for (const k of Object.keys(formGroup.controls)) {
          const ctrl = formGroup.get(k);
          const field = formFields.find((f: any) => f.field == k);
          const foundDefault = defaults.find((f: any) => f.field == k);
          if (foundDefault) {
            if (foundDefault && foundDefault.value && foundDefault.value.toString().length > 0) {
              if (field.type === 'date') {

                const parts = foundDefault.value.split('-');
                const dayCtrl = formGroup.get(k + 'd');
                const monthCtrl = formGroup.get(k + 'm');
                const yearCtrl = formGroup.get(k + 'y');
                if (dayCtrl && monthCtrl && yearCtrl) {
                  if (parts.length >= 1) {
                    yearCtrl.setValue(parts[0]);
                    yearCtrl?.updateValueAndValidity({ onlySelf: true });
                  }
                  if (parts.length >= 2) {
                    monthCtrl.setValue(parts[1]);
                    monthCtrl?.updateValueAndValidity({ onlySelf: true });
                  }
                  if (parts.length >= 3) {
                    dayCtrl.setValue(parts[2]);
                    dayCtrl?.updateValueAndValidity({ onlySelf: true });
                  }
                }
              }
              else {
                ctrl?.setValue(foundDefault.value);
                ctrl?.updateValueAndValidity({ onlySelf: true });
              }
            }
          }
        }
        this.childForms.push(formGroup);
        this.formFields.push(formFields);
        this.formGroups[this.formId] = formGroup;
        this.detailsTitle = this.formService.getDetailsTitle(this.formId);
        await this.preLoadFiles()
        // now set up changes
        this.formChanges(idx);
      }
    }
  }

}
